import React from 'react';
import { RhNumberField } from '../../../../../../../../dum';
import { IOrderSale } from '../../../order-sale-form';
import { useCalculateProductsTotal } from '../../../helpers/use-calculate-products-total';
import { useFormContext, useWatch } from 'react-hook-form';
import {
    GROUP_PRICE,
    ORDER_SALE_PRODUCTS,
} from '../order-sale-products-columns';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderSale = 'order_sale_products';
const ORDER_REQUEST_NAME: keyof IOrderSale = 'order_request';
const KILO_PRICE_FIELD_NAME: keyof IOrderSale['order_sale_products'][number] =
    'kilo_price';

interface IKilosInputProps {
    index: number;
}

export function KiloPriceInput({ index }: IKilosInputProps) {
    const INPUT_NAME = `${ARRAY_NAME}.${index}.${KILO_PRICE_FIELD_NAME}`;
    const { calculateProductsTotal } = useCalculateProductsTotal();
    const rx = useFormContext();
    const groupPrice = useWatch({
        name: `${ORDER_SALE_PRODUCTS}.${index}.${GROUP_PRICE}`,
    }) as IOrderSale['order_sale_products'][number]['group_price'];
    // When the sale is linked to an order request, the price is pinned to the
    // request and locked. Otherwise keep the kilo/group mutual-exclusivity lock.
    const orderRequest = useWatch({
        name: ORDER_REQUEST_NAME,
    }) as IOrderSale['order_request'];

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.kilo_price)}
            disableGutters
            disabled={!!orderRequest || Number(groupPrice) !== 0}
            onChange={() => {
                calculateProductsTotal({ index });
                void rx.trigger(
                    `${ORDER_SALE_PRODUCTS}.${index}.${GROUP_PRICE}`,
                );
            }}
        />
    );
}
